import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_care/activity-calendar")({
  beforeLoad: ({ context }) => guardRoute(context.me, "activity-calendar"),
  component: Outlet,
});
